<template>
  <div>
    <b-card>
      <div class="mb-2 text-right">
        <b-button
          size="sm"
          variant="bagsis"
          :to="{ name: 'plenarias_create' }"
          v-if="$can('plenarias:create')"
        >
          <font-awesome-icon icon="plus" />
          Novo
        </b-button>
      </div>
      <div class="d-flex mb-2">
        <table-header-search
          class="mr-auto w-100"
          :search.sync="termo_pesquisa"
          :filters.sync="filters"
          :external-valid-filters="hasSelectedConselho"
          @search="loadData"
          @clear="clearFilters"
        >
          <template #append>
            <div class="flex-grow-1 mr-1">
              <select-conselho v-model="conselho_id" add-null-value />
            </div>
          </template>
        </table-header-search>
      </div>

      <b-table
        striped
        hover
        :items="plenarias"
        :fields="fields"
        @sort-changed="sortingChanged"
        show-empty
      >
        <template #cell(actions)="row">
          <Actions
            :item="row.item"
            :view_show="false"
            :view_edit="$can('plenarias:edit')"
            :view_delete="$can('plenarias:delete')"
            edit_to="plenarias_edit"
            @delete="delete_plenaria"
          />
        </template>
        <template #empty="{}">
          <h5 class="text-center">Nenhum item encontado</h5>
        </template>
      </b-table>
    </b-card>

    <div>
      <pagination-nav :pagination="pagination" @input="loadData()" />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import SelectConselho from "@/modules/conselhos/Components/SelectConselho.vue";
import TableHeaderSearch from "@/components/Table/TableHeaderSearch.vue";
import { slugify } from "@/helpers/functions/slugify";
import mixins from "@/components/Table/mixins";

export default {
  components: { SelectConselho, TableHeaderSearch },
  mixins: [mixins],
  props: {
    actions: {
      type: String,
      default: "default",
    },
    plenaria_id: {
      required: false,
    },
  },
  data: () => ({
    page: 1,
    termo_pesquisa: "",
    filters: {
      start: "",
      end: "",
    },
    sortBy: "data_reuniao",
    sortDesc: true,
    conselho_id: null,
  }),
  computed: {
    ...mapState("plenarias", ["plenarias", "pagination"]),
    fields() {
      return [
        { key: "actions", label: "", class: "cell-actions" },
        { key: "id", label: "#", class: "col-1" },
        {
          key: "titulo",
          label: "Título",
          class: "col-4 cell-truncate",
          sortable: true,
        },
        {
          key: "conselho.nome",
          label: "Conselho",
          class: "col-4 cell-truncate",
          sortable: true,
        },
        {
          key: "tipo",
          label: "Tipo",
          class: "col-1",
          sortable: true,
          formatter: (value, head, object) => {
            return value == "ordinaria" ? "Ordinária" : "Extraordinária";
          },
        },
        {
          key: "data_reuniao",
          label: "Data",
          class: "col-2",
          sortable: true,
          formatter: (value, head, object) => {
            return this.$options.filters.format_date(value, "DD/MM/Y HH:mm");
          },
        },
      ];
    },
    formatedTermoPesquisa() {
      return slugify(this.termo_pesquisa);
    },
    hasSelectedConselho() {
      return !!this.conselho_id;
    },
  },
  methods: {
    ...mapActions("plenarias", ["ActionGetAll", "ActionDelete"]),
    async loadData(page = -1) {
      this.isBusy = true;
      try {
        if (page > 0) {
          this.pagination.current_page = page;
        }
        const payload = {
          page: this.pagination.current_page,
          per_page: this.pagination.per_page,
          orderBy: this.sortBy,
          sortBy: this.sortDesc ? "desc" : "asc",
          date_ini: this.filters.start,
          date_fim: this.filters.end,
          q: this.formatedTermoPesquisa,
        };

        if (this.conselho_id) {
          payload["conselho_id"] = this.conselho_id;
        }

        await this.ActionGetAll(payload);
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao carregar dados da listagem",
          icon: "exclamation-triangle",
          type: "danger",
        });
      }
      this.isBusy = false;
    },
    async delete_plenaria(plenaria) {
      try {
        await this.ActionDelete(plenaria.id);
        this.$notifications.addNotification({
          message: "Registro deletado com sucesso",
          type: "success",
        });
        await this.loadData();
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao excluir registro",
          type: "danger",
        });
      }
    },
    linkGen(pageNum) {
      return pageNum === 1 ? "?" : `?page=${pageNum}`;
    },
    clearFilters() {
      this.filters = {
        start: "",
        end: "",
      };
      this.termo_pesquisa = "";
      this.pagination.current_page = 1;
      this.conselho_id = null;
      this.loadData();
    },
    /*
    async loadData() {
      try {
        let payload = {
          page: this.page,
          q: this.termo_pesquisa,
          plenaria_id: this.plenaria_id,
        };
        await this.ActionGetAll(payload);
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao carregar dados da listagem",
          icon: "exclamation-triangle",
          type: "danger",
        });
      }
    },
    async created() {
      if (this.$route.query.page > 1) {
        this.page = this.$route.query.page;
      }
      this.loadData();
    },
    */
  },
};
</script>

<style></style>
